document.body.addEventListener('click', function (e) {
    const trigger = e.target.closest('.open-modal');
    console.log(e.target);
    if (trigger) {
        console.log('dog');
        e.preventDefault();
        console.log('Clicked modal trigger');

        document.documentElement.classList.toggle('lock-scroll');

        const postId = e.target.getAttribute('data-post-id');
        if (!postId) {
            console.warn('No post ID found');
            return;
        }

        // Show loading
        document.body.classList.add('modal-loading');
        console.log('Fetching content for post ID:', postId);

        fetch(`/wp-admin/admin-ajax.php?action=load_modal_content&post_id=${postId}`)
            .then(res => res.text())
            .then(html => {
                const modalWrapper = document.createElement('div');
                modalWrapper.classList.add('modal-wrapper');
                modalWrapper.innerHTML = html;
                document.body.appendChild(modalWrapper);

                // Show modal
                modalWrapper.classList.add('is-visible');

                // Close events
                modalWrapper.addEventListener('click', (event) => {
                    const closeTrigger = event.target.closest('.modal-close, .modal-overlay, .modal--projects__overlay, .modal--projects__close');
                    if (closeTrigger) {
                        closeModal(modalWrapper);
                    }
                });
            })
            .catch(err => {
                console.error('Modal AJAX error:', err);
            })
            .finally(() => {
                document.body.classList.remove('modal-loading');
            });
    }
});

function closeModal(modalWrapper) {
    setTimeout(() => {
        console.log('Closing modal');
        if (!modalWrapper) {
            console.error('modalWrapper is undefined or null');
            return;
        }
        modalWrapper.remove();
        document.querySelector('html').classList.remove('lock-scroll');
    }, 300); // Delay to match CSS transition (if any)
}
// Initialize modals
// openModal();
